import { createContext } from 'react';

export const SearchFormContext = createContext();